<template>
  <div class="ClueEntry">
    <van-nav-bar
      fixed
      title="填写产值"
      left-arrow
      @click-left="() => $router.go(-1)"
    />
    <b-row>
      <b-col cols="12">
        <div class="table-condensed mt-5 overflow-auto">
          <table class="table" style="width: 800px" v-if="list.totalCount > 0">
            <thead class="text-nowrap">
              <tr>
                <th>年度</th>
                <th>开票收入</th>
                <th>附件</th>
                <th>提交时间</th>
              </tr>
            </thead>
            <tbody class="  text-nowrap">
              <tr v-for="(item, index) in list.items" :key="index">
                <td>{{ item.outputYear }}</td>
                <td>{{ item.outputIncome }}</td>
                <td v-if="item.fileData && item.fileData.length > 0">
                  <a
                    style="display:block;"
                    target="_blank"
                    :download="items.dataTitle"
                    :href="uploadUrl + items.dataUrl"
                    :title="'点击下载' + items.dataTitle"
                    v-for="(items, index) in item.fileData"
                    :key="index"
                    >{{ items.dataTitle }}</a
                  >
                </td>
                <td v-else>无</td>
                <td>{{ item.creationTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-col cols="12">
          <b-form @submit.prevent="formSubmit">
            <b-form-group
              class="col-md-6 mb-3"
              label="年度"
              label-for="input-1"
            >
              <b-form-input
                required
                v-model="outputYear"
                type="number"
                placeholder="请输入年度"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label="开票收入(万元)"
              label-for="input-1"
            >
              <b-form-input
                required
                v-model="outputIncome"
                type="number"
                placeholder="请填写开票收入"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label="说明：文件大小<50M，最多可上传3个附件"
              label-for="input-1"
            >
              <van-uploader
                v-model="fileList"
                :delete="deletea"
                accept="file"
                multiple
                :after-read="upload"
                :max-count="3"
              >
                <van-button class="paramary_color" icon="plus" type="primary"
                  >上传文件</van-button
                >
              </van-uploader>
            </b-form-group>
            <b-row>
              <b-col md="12 text-center">
                <b-button
                  class="mt-3 button-color"
                  type="submit"
                  variant="primary"
                  >提交</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "OutputValueDetails",
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API,
      list: [],
      fileList: [],
      uploadFile: [],
      outputYear: "",
      outputIncome: "",
    };
  },
  methods: {
    deletea(data) {
      // console.log(data);
    },
    formSubmit(evt) {
      evt.preventDefault();
      this.request({
        url: "/v1.0/ThePublic/outputValueInput",
        method: "POST",
        data: {
          projectId: this.$route.params.id,
          outputYear: Number(this.outputYear),
          outputIncome: Number(this.outputIncome),
          fileData: this.uploadFile,
        },
      }).then((res) => {
        if (res.success) {
          this.$toast("提交成功");
          this.search();
          this.uploadFile = [];
          this.outputYear = "";
          this.outputIncome = "";
          this.fileList = [];
        }
      });
    },
    upload(file) {
      file.status = "uploading";
      file.message = "上传中...";
      var formData = new FormData();
      this.fileList.forEach((ele) => {
        // console.log(ele.file)
        formData.append("file", ele.file);
      });
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          this.currentRate = Number(
            ((progressEvent.loaded / progressEvent.total) * 100) | 0
          );
        },
      };
      var url = `/v1.0/Upload/projectUpload/${this.$route.params.id}`;
      this.request.post(url, formData, config).then((res) => {
        if (res.success) {
          this.uploadFile.push({
            dataTitle: res.data.fileName,
            dataUrl: res.data.fileSrc,
            ext: res.data.creationTime,
          });
          if (this.currentRate == 100) {
            file.status = "";
            file.message = "";
          }
        } else {
          file.status = "failed";
          file.message = "上传失败";
        }
        // console.log(res);
      });
    },
    search() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.request({
        url: "/v1.0/ThePublic/getOutputValuePaged",
        method: "GET",
        params: {
          ProjectId: this.$route.params.id,
          PageSize: 5,
          PageIndex: 1,
        },
      }).then((res) => {
        this.$toast.clear();
        if (res.success) {
          this.list = res.data;

          // console.log(this.list, 1234);
        }
        this.loading = false;
      });
    },
  },
  created() {
    this.search();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.ClueEntry {
  th {
    text-align: center;
  }
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 2;
}
</style>
